module.exports = {
  schema: {
    name: '品牌資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '品牌編號',
      },
      name: {
        type: 'String',
        name: '品牌名稱',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key' },
        { key: 'name' },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/brands.js